import React, { useEffect, useState } from "react";
import "../../Dashboard/pages/pages.css";
import api from "../../utilis/api";
const AdminOverview = () => {
  const [teacherCount, setTeacherCount] = useState(0);
  const [studentCount, setStudentCount] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);

  const getUsers = async () => {
    try {
      const response = await api.get("/user/all"); // fetch all users
      const users = response.data.data; // assuming your API returns { data: [...] }
      console.log(response);
      // total users
      setTotalUsers(users.length);

      // filter teachers
      const teachers = users.filter((u) => u.role === "teacher");
      setTeacherCount(teachers.length);

      // filter students
      const students = users.filter((u) => u.role === "student");
      setStudentCount(students.length);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);
  return (
    <div className="overview-container">
      <header className="overview-header">
        <div className="header-text">
          <span className="header-subtitle">Welcome Back, Robert</span>
          <h1 className="header-title">Admin Dashboard</h1>
        </div>
        <div className="user-profile">
          {/* Profile Icon or search can go here */}
        </div>
      </header>
      <div
        className="dashboard-grid"
        style={{
          gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
          gap: "1rem",
          marginBottom: "1rem",
        }}
      >
        <section className="card">
          <h3>Total Students</h3>
          <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>{studentCount}+</p>
        </section>
        <section className="card">
          <h3>Total Teachers</h3>
          <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>{teacherCount}+</p>
        </section>
        <section className="card">
          <h3>Total Users</h3>
          <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>{totalUsers}+</p>
        </section>
      </div>
    </div>
  );
};

export default AdminOverview;
